export class DefaultExtraFeeMembershipPriceApiModel {
  isAppliedOnOrder: boolean;

  membershipLevel: number;

  membershipCardTypeId: string;

  membershipDefaultExtraFeePrice: number;
}
